import React, { useEffect, useRef, createElement } from 'react';
import { useCheckout } from './CheckoutContext';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/hvxLSXHiFPRBSASz9eWkeB/realmanifestacion_200kb.webp';
export function Hero() {
  const {
    openUpsell,
    warmConnection
  } = useCheckout();
  const ctaRef = useRef<HTMLButtonElement | null>(null);
  // Preload the above-the-fold hero image as early as possible to improve LCP
  useEffect(() => {
    const existing = document.querySelector(`link[rel="preload"][href="${HERO_IMAGE}"]`);
    if (existing) return;
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = HERO_IMAGE;
    link.setAttribute('fetchpriority', 'high');
    document.head.appendChild(link);
  }, []);
  // Warm the checkout connection when the primary CTA enters the viewport.
  useEffect(() => {
    const el = ctaRef.current;
    if (!el || typeof IntersectionObserver === 'undefined') return;
    const observer = new IntersectionObserver(entries => {
      if (entries.some(e => e.isIntersecting)) {
        warmConnection();
        observer.disconnect();
      }
    }, {
      rootMargin: '0px',
      threshold: 0.1
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [warmConnection]);
  return <section className="relative px-4 pt-5 pb-7 sm:pt-7 sm:pb-9" data-id="element-136">
      <div className="max-w-4xl mx-auto text-center" data-id="element-137">
        {/* Badges */}
        <div className="flex flex-wrap items-center justify-center gap-1.5 mb-3" data-id="element-138">
          <div className="inline-block px-3 py-1 rounded-full border border-brand-gold/30 bg-brand-gold/5 text-[10px] sm:text-xs text-brand-gold" data-id="element-139">
            +18.000 personas ya aplicaron este método
          </div>
          <div className="inline-block px-3 py-1 rounded-full border border-brand-gold/30 bg-brand-gold/5 text-[10px] sm:text-xs text-brand-gold" data-id="element-140">
            Método de transformación consciente
          </div>
        </div>

        {/* Main Title */}
        <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-2 leading-[1.05]" data-id="element-141">
          TODO LO QUE PEDISTE <span className="text-brand-gold" data-id="element-142">YA EXISTE</span>
        </h1>

        {/* Subtitle */}
        <p className="text-sm sm:text-base md:text-lg text-brand-gold mb-4 sm:mb-5 font-light max-w-2xl mx-auto" data-id="element-143">
          Lo único que falta es convertirte en la persona capaz de recibirlo.
        </p>

        {/* Product Image */}
        <div className="relative mb-4 sm:mb-5" data-id="element-144">
          <div className="absolute inset-0 bg-brand-gold/10 blur-3xl rounded-full" data-id="element-145"></div>
          <img src={HERO_IMAGE} alt="Realmanifestación - Manifestación Consciente" className="relative w-full max-w-lg mx-auto" loading="eager" fetchPriority="high" decoding="async" width={512} height={512} data-id="element-146" />
        </div>

        {/* Price */}
        <div className="mb-3" data-id="element-147">
          <p className="text-brand-gray line-through text-sm sm:text-base mb-0" data-id="element-148">
            $50.000 ARS
          </p>
          <p className="text-brand-gold text-3xl sm:text-4xl font-bold leading-tight" data-id="element-149">
            $19.990 ARS
          </p>
        </div>

        {/* Bullets */}
        <div className="grid grid-cols-2 gap-x-4 gap-y-1.5 max-w-md mx-auto mb-5 text-left" data-id="element-150">
          {['Acceso inmediato', 'Formato digital', 'Compatible celular y PC', 'Garantía de 7 días'].map((item, i) => <div key={i} className="flex items-center gap-2 text-xs sm:text-sm" data-id="element-151">
              <span className="text-brand-gold" data-id="element-152">✓</span>
              <span data-id="element-153">{item}</span>
            </div>)}
        </div>

        {/* CTA Button */}
        <button ref={ctaRef} onClick={openUpsell} onMouseEnter={warmConnection} onTouchStart={warmConnection} className="w-full sm:w-auto bg-brand-gold text-brand-black px-8 py-3.5 sm:px-10 sm:py-4 rounded text-base sm:text-lg font-bold hover:opacity-90 transition-all hover:scale-[1.02] mb-2" data-id="element-154">
          QUIERO ACCESO INMEDIATO
        </button>

        {/* Trust Badge */}
        <p className="text-[11px] sm:text-xs text-brand-gray" data-id="element-155">
          Pago 100% seguro · SSL
        </p>
      </div>
    </section>;
}